import Cookies from 'universal-cookie'
import moment from 'moment'
import { version } from '../../package.json'

/**
 * @type Cookies :: @ref https://www.npmjs.com/package/universal-cookie
 *
 * accessCookies :: () -> Cookies
 */
const accessCookies = (() => {
  let instance = null
  return () => {
    if (!instance) {
      instance = new Cookies()
    }
    return instance
  }
})()

// getCookie :: String -> Maybe String
export const getCookie = label => accessCookies().get(label)

// removeCookie :: String -> ()
export const removeCookie = label => accessCookies().remove(label)

// hasCookie :: String -> Boolean
export const hasCookie = label => !!getCookie(label)

// setCookie :: String -> * -> ()
export const setCookie = label => value => accessCookies().set(label, value, {
  path: '/',
  expires: moment().add(100, 'years').toDate(),
})

// Clé localStorage pour la version (remplace le cookie 'latestVersion')
const VERSION_STORAGE_KEY = 'primview_version'

/**
 * initializeVersion :: () -> ()
 *
 * Stocke la version courante dans localStorage.
 * Migration automatique : si l'ancienne valeur était dans un cookie,
 * on la transfère puis on supprime le cookie pour libérer de l'espace.
 */
export const initializeVersion = () => {
  // Migration du cookie vers localStorage (une seule fois)
  if (hasCookie('latestVersion')) {
    // Supprimer le cookie (les cookies persistent dans les requêtes HTTP - inutile ici)
    removeCookie('latestVersion')
  }

  // Toujours mettre à jour la version avec celle du build courant
  localStorage.setItem(VERSION_STORAGE_KEY, version)
}

/**
 * getVersion :: () -> String
 *
 * Retourne la version stockée dans localStorage, ou la version du package par défaut.
 */
export const getVersion = () => {
  return localStorage.getItem(VERSION_STORAGE_KEY) || version
}
